import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}/document-types`;

const createDocumentType = async (payload) => {
  const { data } = await axios.post(apiUrl, payload);

  return data;
}

const updateDocumentType = async ({ documentTypeId, updateData }) => {
  const { data } = await axios.put(`${apiUrl}/${documentTypeId}`, updateData);

  return data;
}

const deleteDocumentType = async (documentTypeId) => {
  await axios.delete(`${apiUrl}/${documentTypeId}`);
}

const documentTypeService = {
  createDocumentType,
  updateDocumentType,
  deleteDocumentType
};

export default documentTypeService;
